(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["atnt-discovery-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('atnt-card-media')) {
  customElements.define('atnt-card-media', class extends HTMLElement {
    connectedCallback() {
      if (this.ready || this.dataset.kind !== 'sweat') return;
      this.ready = true;
      const img = this.querySelector('img');
      if (!img) return;
      const align = () => {
        try {
          const canvas = document.createElement('canvas');
          const ratio = Math.min(160 / img.naturalWidth, 160 / img.naturalHeight);
          if (!Number.isFinite(ratio) || ratio <= 0) return;
          const w = canvas.width = Math.max(1, Math.round(img.naturalWidth * ratio));
          const h = canvas.height = Math.max(1, Math.round(img.naturalHeight * ratio));
          const ctx = canvas.getContext('2d', {willReadFrequently:true});
          ctx.drawImage(img, 0, 0, w, h);
          const pixels = ctx.getImageData(0,0,w,h).data;
          const rgb = (x,y) => {
            const i = (y*w+x)*4, a=pixels[i+3]/255;
            return [0,1,2].map(c => pixels[i+c]*a+255*(1-a));
          };
          const corners = [rgb(2,2),rgb(w-3,2),rgb(2,h-3),rgb(w-3,h-3)];
          const bg = [0,1,2].map(c=>corners.map(p=>p[c]).sort((a,b)=>a-b)[2]);
          if (Math.min(...bg)<180) return;
          const distance = p => Math.max(...p.map((v,c)=>Math.abs(v-bg[c])));
          if (corners.some(p=>distance(p)>30)) return;
          let x0=w,y0=h,x1=0,y1=0, count=0;
          for (let y=2;y<h-2;y++) for(let x=2;x<w-2;x++) {
            if(distance(rgb(x,y))>22) {
              x0=Math.min(x0,x);x1=Math.max(x1,x);
              y0=Math.min(y0,y);y1=Math.max(y1,y);count++;
            }
          }
          const bw=x1-x0+1,bh=y1-y0+1;
          if(count<w*h*.08 || bh<h*.4 || bw<w*.2 || x0<=2 || x1>=w-3 || y0<=2 || y1>=h-3) return;
          const scale=Math.min(.80/bh,.92*.75/bw);
          img.style.width=(w*scale/.75*100)+'%';
          img.style.height=(h*scale*100)+'%';
          img.style.left=((.375-(x0+bw/2)*scale)/.75*100)+'%';
          img.style.top=((.5-(y0+bh/2)*scale)*100)+'%';
          img.classList.add('atnt-card-image--aligned');
        } catch (_) {}
      };
      img.addEventListener('load', align);
      if (img.complete && img.naturalWidth) align();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["atnt-mystery-upsell"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('atnt-mystery-upsell')) return;
  const selections = new Map();
  const pending = new Set();
  class AtntMysteryUpsell extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.initialize(), { once:true });
      } else this.initialize();
    }
    initialize() {
      if (!this.isConnected || this.initialized) return;
      this.form = this.closest('form');
      this.checkbox = this.querySelector('input[type="checkbox"]');
      if (!this.form || !this.checkbox) return;
      try { this.variants = JSON.parse(this.dataset.variants); } catch (_) { return; }
      this.initialized = true;
      this.checkbox.checked = selections.get(this.dataset.formId) === true;
      this.checkbox.addEventListener('change', () => {
        selections.set(this.dataset.formId, this.checkbox.checked);
        this.refresh();
      });
      this.hidden = false;
      this.refresh();
    }
    selectedVariant() {
      const id = new FormData(this.form).get('id');
      return this.variants.find(variant => String(variant.id) === String(id));
    }
    refresh() {
      const variant = this.selectedVariant() || this.variants.find(item => String(item.id) === this.dataset.selectedId);
      const selected = this.checkbox.checked;
      this.form.classList.toggle('atnt-mystery-extra-selected', selected);
      if (!variant) return;
      const cents = variant.price + (selected ? Number(this.dataset.extraPrice) : 0);
      this.querySelector('[data-total]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style:'currency', currency:this.dataset.currency || 'EUR'
      }).format(cents / 100);
    }
    async addBox(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const formId = this.dataset.formId;
      if (pending.has(formId)) return;
      const errorElement = this.querySelector('.atnt-mystery-upsell__error');
      const report = message => {
        this.querySelector('[data-error]').textContent = message;
        errorElement.hidden = false;
      };
      errorElement.hidden = true;
      const variant = this.selectedVariant();
      const data = new FormData(this.form);
      const quantity = Number(data.get('quantity') || 1);
      if (!variant || !variant.available || !Number.isSafeInteger(quantity) || quantity < 1) {
        report('Choisis une taille disponible et une quantité valide.');
        return;
      }
      const properties = {};
      for (const [key, value] of data.entries()) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && typeof value === 'string') properties[match[1]] = value;
      }
      // Separate each enriched box group from regular boxes already in the cart.
      const group = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      properties._atnt_mystery_group = group;
      const parent = { id:variant.id, quantity, properties };
      if (data.get('selling_plan')) parent.selling_plan = data.get('selling_plan');
      const child = {
        id:Number(this.dataset.extraId), quantity, parent_id:variant.id,
        properties:{ 'Taille de la Mystery Box':variant.option1, '_atnt_mystery_group':group }
      };
      pending.add(formId);
      this.form.setAttribute('aria-busy','true');
      this.checkbox.disabled = true;
      const submitter = event.submitter;
      const wasDisabled = submitter ? submitter.disabled : false;
      if (submitter) submitter.disabled = true;
      try {
        const response = await fetch(this.dataset.addUrl, {
          method:'POST', credentials:'same-origin',
          headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
          body:JSON.stringify({ items:[parent, child] })
        });
        const result = await response.json();
        if (!response.ok || result.status >= 400) {
          const detail = typeof result.description === 'string' ? result.description : 'L’ajout de la box avec son supplément n’a pas pu être confirmé.';
          report(detail + ' Vérifie ton panier avant de réessayer.');
          return;
        }
        window.location.assign(this.dataset.cartUrl);
      } catch (_) {
        // No automatic retry: the server may have accepted a request whose reply was lost.
        report('L’ajout n’a pas pu être confirmé. Vérifie ton panier avant de réessayer.');
      } finally {
        pending.delete(formId);
        this.form.removeAttribute('aria-busy');
        this.checkbox.disabled = false;
        if (submitter) submitter.disabled = wasDisabled;
      }
    }
  }
  customElements.define('atnt-mystery-upsell', AtntMysteryUpsell);
  document.addEventListener('submit', event => {
    if (!(event.target instanceof HTMLFormElement)) return;
    const upsell = event.target.querySelector('atnt-mystery-upsell');
    if (upsell && !upsell.hidden && upsell.checkbox && upsell.checkbox.checked) upsell.addBox(event);
  }, true);
  document.addEventListener('change', event => {
    const form = event.target.form;
    if (!form) return;
    requestAnimationFrame(() => {
      const upsell = form.querySelector('atnt-mystery-upsell');
      if (upsell && !upsell.hidden) upsell.refresh();
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["atnt-size-finder"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('atnt-size-finder')) return;
  const normalized = value => String(value).trim().toUpperCase().replace(/^.*\((XXL|XXXL)\)$/, '$1').replace(/^XXL$/, '2XL').replace(/^XXXL$/, '3XL');
  const clean = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\s+/g, ' ').trim();
  function heightRange(value) {
    const s = clean(value).split(/\(ex/)[0];
    let numbers = [...s.matchAll(/(\d)\s*m\s*(\d{2})/g)].map(m => Number(m[1]) * 100 + Number(m[2]));
    if (!numbers.length && /cm/.test(s)) numbers = [...s.matchAll(/\b(1\d{2}|2[0-2]\d|230)\b/g)].map(m => Number(m[1]));
    if (numbers.length === 1 && /jusqu|moins/.test(s)) return [0, numbers[0]];
    if (numbers.length === 1 && /partir|plus|dessus/.test(s)) return [numbers[0], Infinity];
    if (numbers.length === 2 && numbers[0] < numbers[1]) return numbers;
    return null;
  }
  function parseGuide(description) {
    const doc = new DOMParser().parseFromString(description, 'text/html');
    const candidates = [];
    for (const table of doc.querySelectorAll('table')) {
      const rows = [...table.rows];
      if (rows.length < 3) continue;
      const header = [...rows[0].cells].map(c => clean(c.textContent));
      if (header.length !== 2 || !/taille|size/.test(header[0]) || !/taille|hauteur|stature/.test(header[1])) continue;
      const parsed = rows.slice(1).map(row => {
        if (row.cells.length !== 2) return null;
        const size = row.cells[0].textContent.trim();
        const label = row.cells[1].textContent.trim();
        const range = heightRange(label);
        return /^(XXS|XS|S|M|L|XL|XXL|XXXL|2XL|3XL)$/i.test(size) && range ? {size, label, min:range[0], max:range[1]} : null;
      });
      if (parsed.some(x => !x)) continue;
      parsed.sort((a,b) => a.min-b.min);
      if (new Set(parsed.map(r=>normalized(r.size))).size !== parsed.length) continue;
      if (parsed.some((r,i) => i > 0 && r.min < parsed[i-1].max)) continue;
      candidates.push(parsed);
    }
    return candidates.length === 1 ? candidates[0] : [];
  }
  function parseGarmentGuide(description) {
    const doc = new DOMParser().parseFromString(description, 'text/html');
    const candidates = [];
    const number = value => { const match=String(value).trim().match(/^(\d+(?:[.,]\d+)?)(?:\s*cm)?$/i); return match ? Number(match[1].replace(',', '.')) : NaN; };
    for (const table of doc.querySelectorAll('table')) {
      const rows=[...table.rows]; if(rows.length<3) continue;
      const headings=[...rows[0].cells].map(c=>clean(c.textContent));
      const si=headings.findIndex(h=>h==='taille'||h==='size');
      const wi=headings.findIndex(h=>/largeur.*poitrine/.test(h));
      const li=headings.findIndex(h=>/^longueur(?:\s|$|\()/.test(h));
      if(si<0||wi<0||li<0)continue;
      const parsed=rows.slice(1).map(row=>({size:row.cells[si]?.textContent.trim(),width:number(row.cells[wi]?.textContent),length:number(row.cells[li]?.textContent)}));
      if(parsed.some(row=>!/^(XXS|XS|S|M|L|XL|XXL|XXXL|[2-5]XL)$/i.test(row.size)||!Number.isFinite(row.width)||!Number.isFinite(row.length)||row.width<20||row.length<30))continue;
      if(new Set(parsed.map(row=>normalized(row.size))).size!==parsed.length)continue;
      candidates.push(parsed.sort((a,b)=>a.width-b.width));
    }
    return candidates.length===1?candidates[0]:[];
  }
  class AtntSizeFinder extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      try { this.config = JSON.parse(this.dataset.config); } catch (_) { return; }
      this.t = this.config.i18n;
      this.isTee = /\b(?:t[ -]?shirts?|tee)/i.test(this.config.title) && !/sweat/i.test(this.config.title);
      this.rows = parseGuide(this.config.description);
      this.garmentRows = parseGarmentGuide(this.config.description);
      this.hasHeightGuide = !this.isTee && this.rows.length > 0;
      if(!this.hasHeightGuide)this.querySelector('[data-profile-help]').textContent=this.t.profile_without_size;
      this.fit = 'regular';
      const adviceDoc = new DOMParser().parseFromString(this.config.description, 'text/html');
      const adviceTable = [...adviceDoc.querySelectorAll('table')].find(table => /taille|hauteur|stature/i.test(table.rows[0]?.textContent || ''));
      let adviceElement = adviceTable?.nextElementSibling;
      let adviceText = '';
      while (adviceElement && !/^H[1-6]$/.test(adviceElement.tagName)) {
        if (adviceElement.tagName === 'P' && /taille|coupe|oversize|fit|size/i.test(adviceElement.textContent)) { adviceText = adviceElement.textContent.trim(); break; }
        adviceElement = adviceElement.nextElementSibling;
      }
      if (!adviceText) {
        adviceText = [...adviceDoc.querySelectorAll('p, li')].map(el => el.textContent.trim()).find(text => /taille habituelle|corpulence moyenne|guide taille|taille normalement/i.test(text)) || '';
      }
      this.adviceText = adviceText;
      this.querySelector('[data-product-advice]').textContent = adviceText;
      this.querySelector('.af-advice').hidden = !adviceText;

      this.dialog = this.querySelector('dialog');
      this.addEventListener('change', e => e.stopPropagation());
      this.field = this.querySelector('input[name=height]');
      this.weightField = this.querySelector('input[name=weight]');
      this.ageField = this.querySelector('input[name=age]');
      this.querySelector('[data-product]').textContent = this.config.title;
      this.allowOversize = true;
      this.querySelector('[data-fit=oversize]').hidden = false;
      this.querySelector('[data-open]').addEventListener('click', e => {
        e.preventDefault(); this.returnFocus=e.currentTarget;
        this.show(1);
        this.dialog.showModal();
        this.querySelector('[data-title]').focus();
      });
      this.querySelector('[data-close]').addEventListener('click',()=>this.dialog.close());
      this.dialog.addEventListener('close',()=>{this.returnFocus?.focus();});
      this.dialog.addEventListener('click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();}});
      this.querySelector('[data-height-form]').addEventListener('submit',e=>{
        e.preventDefault(); e.stopPropagation();
        const h=Number(this.field.value.replace(',','.'));
        const valid=this.field.value.trim()!=='' && Number.isFinite(h) && h>=100 && h<=230;
        this.querySelector('.af-error').hidden=valid;
        this.field.setAttribute('aria-invalid',String(!valid));
        if(!valid){this.field.focus();return;}
        let firstInvalid = null;
        const optionalNumber = (field, errorSelector, max, integer) => {
          const raw = field.value.trim();
          const value = Number(raw.replace(',', '.'));
          const ok = !field.validity.badInput && (raw === '' || (Number.isFinite(value) && value >= 1 && value <= max && (!integer || Number.isInteger(value))));
          this.querySelector(errorSelector).hidden = ok;
          field.setAttribute('aria-invalid', String(!ok));
          if (!ok && !firstInvalid) firstInvalid = field;
          return raw === '' ? null : value;
        };
        this.weight = optionalNumber(this.weightField, '[data-weight-error]', 500, false);
        this.age = optionalNumber(this.ageField, '[data-age-error]', 120, true);
        if (firstInvalid) { firstInvalid.focus(); return; }
        this.height=h;
        this.querySelector('[data-profile-values]').textContent = [`${h} cm`, this.weight === null ? '' : `${this.weight} kg`, this.age === null ? '' : `${this.age} ${this.t.years}`].filter(Boolean).join(' · ');
        this.show(2);
      });
      this.querySelectorAll('[data-fit]').forEach(button=>button.addEventListener('click',()=>{
        this.fit=button.dataset.fit;
        this.querySelectorAll('[data-fit]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
      }));
      this.querySelector('[data-recommend]').addEventListener('click',()=>this.recommend());
      this.querySelector('[data-back]').addEventListener('click',()=>this.show(1));
      this.querySelectorAll('[data-restart]').forEach(button=>button.addEventListener('click',()=>this.show(1)));
      if(this.isTee && !this.garmentRows.length){this.config.guideUrl='mailto:contact@atntparis.com';this.querySelector('[data-fallback] p').textContent=this.t.tee_no_guide;this.querySelector('[data-guide-link]').textContent=this.t.ask_size;}
      this.querySelector('[data-guide-link]').href=this.config.guideUrl;
      const source=this.querySelector('[data-source-table]');
      if(this.garmentRows.length){
        const table=document.createElement('table');const caption=document.createElement('caption');caption.textContent=this.t.source_label;table.append(caption);
        const body=document.createElement('tbody');
        this.garmentRows.forEach(row=>{const tr=document.createElement('tr');const th=document.createElement('th');th.scope='row';th.textContent=row.size;const td=document.createElement('td');td.textContent=`${this.t.width_short} ${row.width} cm · ${this.t.length_short} ${row.length} cm`;tr.append(th,td);body.append(tr);});table.append(body);source.append(table);
      }else if(this.rows.length){
        const table=document.createElement('table');
        const cap=document.createElement('caption');cap.textContent=this.t.source_label;table.append(cap);
        const body=document.createElement('tbody');
        this.rows.forEach(row=>{const tr=document.createElement('tr');const th=document.createElement('th');th.scope='row';th.textContent=row.size;const td=document.createElement('td');td.textContent=row.label;tr.append(th,td);body.append(tr);});
        table.append(body);source.append(table);
      }else{
        const a=document.createElement('a');a.href=this.config.guideUrl;a.textContent=this.isTee?this.t.ask_size:this.t.guide;source.append(a);
      }
    }
    show(step){
      this.querySelector('[data-profile-summary]').hidden = step !== 0 && step !== 3;
      this.querySelector('.af-advice').hidden = !this.adviceText || (step !== 0 && step !== 3);
      this.querySelector('[data-height-form]').hidden=step!==1;
      this.querySelector('[data-fit-panel]').hidden=step!==2;
      this.querySelector('[data-result-panel]').hidden=step!==3;
      this.querySelector('[data-fallback]').hidden=step!==0;
      this.querySelector('[data-title]').textContent=this.t[step===1?'height_title':step===2?'fit_title':step===3?'result_title':'guide_only_title'];
      this.querySelector('[data-progress]').textContent=step===1||step===2?`${this.t.step} ${step} ${this.t.of} 2`:'';
      this.querySelector('[data-intro]').textContent=step===2?this.t.fit_intro:this.t.intro;
      this.querySelector('[data-intro]').hidden=step===3||step===0;
      this.querySelector('[data-title]').focus();
      this.dialog.scrollTop=0;
    }
    currentVariant(){
      const urlId=new URL(window.location.href).searchParams.get('variant');
      const section=this.closest('.shopify-section')||document;
      const form=document.getElementById(this.config.formId)||section.querySelector('form[action*="/cart/add"]');
      const formId=form?.querySelector('[name="id"]')?.value;
      return this.config.variants.find(v=>String(v.id)===String(formId||urlId))||this.config.variants.find(v=>String(v.id)===String(this.config.currentVariantId));
    }
    matchingVariant(size){
      const index=this.config.sizeIndex;
      const current=this.currentVariant();
      if(index<0 || !current) return null;
      return this.config.variants.find(v=>normalized(v.options[index])===normalized(size)&&v.options.every((opt,i)=>i===index||opt===current.options[i]))||null;
    }
    recommend(){
      if(!this.hasHeightGuide){
        const label=this.t[this.fit==='oversize'?'oversize':'regular'];
        this.querySelector('[data-profile-values]').textContent=[`${this.height} cm`,this.weight===null?'':`${this.weight} kg`,this.age===null?'':`${this.age} ${this.t.years}`,`${this.t.fit_chosen} ${label}`].filter(Boolean).join(' · ');
        this.querySelector('[data-fallback] p').textContent=this.garmentRows.length?this.t.guide_only_note:this.t.guide_without_height;
        this.querySelector('[data-guide-link]').hidden=this.garmentRows.length>0;
        this.querySelector('.af-source').open=this.garmentRows.length>0;
        this.show(0);return;
      }
      const order=['XXS','XS','S','M','L','XL','2XL','3XL','4XL','5XL'];
      const limits=order.slice(1,6);
      const offered=limits.filter(size=>this.config.variants.some(v=>normalized(v.options[this.config.sizeIndex])===size));
      const allowed=offered.length?offered:limits;
      let base=[];
      let outsideLow=false,outsideHigh=false;
      {
        const matches=this.rows.filter(row=>this.height>=row.min&&this.height<=row.max);
        base=matches.map(row=>normalized(row.size));
        if(!base.length&&this.rows.length){
          const first=this.rows[0],last=this.rows[this.rows.length-1];
          outsideLow=this.height<first.min;outsideHigh=this.height>last.max;
          if(outsideLow)base=[normalized(first.size)];
          else if(outsideHigh)base=[normalized(last.size)];
          else{
            const distances=this.rows.map(row=>({row,d:Math.min(Math.abs(this.height-row.min),Math.abs(this.height-row.max))}));
            const nearest=Math.min(...distances.map(x=>x.d));base=distances.filter(x=>x.d===nearest).map(x=>normalized(x.row.size));
          }
        }
      }
      const result=[];let minimum=outsideLow,maximum=outsideHigh;
      const low=order.indexOf(allowed[0]),high=order.indexOf(allowed[allowed.length-1]);
      for(const size of base){
        const index=order.indexOf(size);if(index<0)continue;
        const wanted=index+(this.fit==='oversize'?1:0);
        if(wanted<low)minimum=true;if(wanted>high)maximum=true;
        const capped=Math.max(low,Math.min(high,wanted));
        const choice=allowed.reduce((best,s)=>Math.abs(order.indexOf(s)-capped)<Math.abs(order.indexOf(best)-capped)?s:best,allowed[0]);
        if(!result.includes(choice))result.push(choice);
      }
      const message=[result.length>1?this.t.between:'',minimum?this.t.min_size_note:'',maximum?this.t.max_size_note:''].filter(Boolean).join(' ');
      this.renderRecommendation(result,this.t[this.fit==='oversize'?'result_oversize':'result_regular'],message);
    }
    renderRecommendation(result,label,message){
      this.querySelector('[data-size]').textContent=result.length?result.join(' / '):'—';
      this.querySelector('[data-fit-label]').textContent=label;
      this.querySelector('[data-result-message]').textContent=message;
      this.querySelector('[data-result-note]').textContent=this.t.result_note;
      const actions=this.querySelector('[data-actions]');actions.replaceChildren();
      result.forEach(size=>{
        const variant=this.matchingVariant(size);
        const exists=this.config.sizeIndex>=0 && this.config.variants.some(v=>normalized(v.options[this.config.sizeIndex])===normalized(size));
        if(!variant?.available){const p=document.createElement('p');p.className='af-note';p.textContent=`${size} — ${exists?this.t.unavailable:this.t.missing}`;actions.append(p);return;}
        const button=document.createElement('button');button.type='button';button.className='af-primary';button.textContent=`${this.t.select} ${size}`;
        button.addEventListener('click',()=>{
          if(this.config.demo){document.querySelectorAll('[data-demo-size]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.demoSize===size)));document.querySelector('[data-demo-status]').textContent=`${this.t.selected_demo} ${size}`;this.dialog.close();return;}
          const fresh=this.matchingVariant(size);
          if(!fresh?.available){this.recommend();return;}
          const url=new URL(this.config.productUrl,window.location.origin);url.searchParams.set('variant',String(fresh.id));const preview=new URL(window.location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);window.location.assign(url.href);
        });actions.append(button);
      });
      this.show(3);
    }
  }
  customElements.define('atnt-size-finder',AtntSizeFinder);
})();
  } catch(e) { console.error(e); }
})();

})();
